'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";

export default ['$scope', '$uibModalInstance', 'planFund', 'CountryRestService', 'edit', 'QuarterRestService',
    function ($scope, $modalInstance, planFund, CountryRestService, edit, QuarterRestService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.setSrcCategory = setSrcCategory;
        $scope.edit = edit;

        $scope.requiredBase = false;
        $scope.planFund = angular.copy(planFund);

        if (!$scope.planFund.country)
            $scope.planFund.country = {};

        // region Function

        function ok() {
            $modalInstance.close($scope.planFund);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function setSrcCategory(item) {
            $scope.planFund.srcCategory = item;
            $scope.srcCategory = item;
        }

        function checkRequiredBase() {
            if (Array.isArray($scope.planFund.attachments))
                $scope.requiredBase = ($scope.planFund.base != null && $scope.planFund.base != "") || $scope.planFund.attachments.length > 0;
            else
                $scope.requiredBase = $scope.planFund.base != null && $scope.planFund.base != "";

            // if (Array.isArray($scope.planFund.attachments)) {
            //     $scope.requiredBase = $scope.planFund.attachments.length > 0;
            // }

            $scope.requiredSrcCategory = $scope.planFund.srcCategory != null && $scope.planFund.srcCategory.id != null;
        }

        // endregion

        // region Watcher

        $scope.$watch('planFund.country.id', function () {
            if ($scope.planFund.country.id)
                CountryRestService.get({countryId: $scope.planFund.country.id}, (data) => $scope.planFund.country = data._embedded);
        });

        $scope.$watch('planFund.base', function () {
            checkRequiredBase();
        });

        $scope.$watch('planFund.srcCategory', function () {
            checkRequiredBase();
        });

        $scope.$watch('planFund.attachments[0]', function () {
            checkRequiredBase();
        });

        // endregion

    }];